import { useCallback } from 'react';
import { getCleanUrl } from 'js/utils/url.util';

import { useContainingIdPages } from './useContainingIdPages';

export const useClearIdsInPath = () => {
    const containingIdPages = useContainingIdPages();

    return useCallback((pathname) => {
        const cleanUrl = getCleanUrl(pathname);

        return containingIdPages.find(page => cleanUrl.startsWith(`${page}/`) || cleanUrl === page)
            || pathname;
    }, [containingIdPages]);
};
